// @flow
import React, { useContext } from 'react';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { WarningMessageContainer } from '@presentational/messages/WarningMessageContainer';
import { getIfCustomerViewIsEnabled } from '@src/common-utils/utils';
import { If } from '@presentational/If';

export const SPKafkaClustersAlertContainer = () => {
  const commitData = useContext(SPUserCommitDetailsContext);
  const spOrgData = useContext(SPOrgContext);
  const isCustomerViewEnabled = getIfCustomerViewIsEnabled(spOrgData);
  const isClustersAlertSentByBE =
    commitData?.alert_aggregations?.cluster_alert?.show_cluster_alert ?? false;
  const shouldShowAlert = isClustersAlertSentByBE && !isCustomerViewEnabled;

  return (
    <If test={shouldShowAlert}>
      <WarningMessageContainer message="ALERT: High Kafka cluster count, customer is eligible for additional Kafka-specific discounts. Do NOT quote list price on Kafka for this account." />
    </If>
  );
};
